import Pager from '@/shared/pager/pager';
import service from './club-history-single-service';

export default {
  namespaced: true,

  state: {
    loading: false,
    list: [],
    pager: new Pager([
      'modifiedBy.email',
      'createdBy.email',
      'deletedBy.email',
      'name',
    ]),
    model: null
  },

  getters: {
    loading: (state) => state.loading,
    list: (state) => state.list,
    pager: (state) => state.pager,
    model: (state) => state.model
  },

  mutations: {
    LOADING(state, payload) {
      state.loading = !!payload;
    },

    LIST(state, payload) {
      state.list = payload || [];
    },

    MODEL(state, payload) {
      state.model = payload;
    },

    CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = new Pager([
        'modifiedBy.email',
        'createdBy.email',
        'deletedBy.email',
        'name',
      ]);
      state.model = null;
    }
  },

  actions: {
    setup({ commit, dispatch, getters }, id) {
      commit('LOADING', true);

      return dispatch('list', id).then(() => {
        if (!getters.list || !getters.list.length) {
          commit('MODEL', {});
        } else {
          commit('MODEL', getters.list[0]);
        }

        commit('LOADING', false);
      });
    },

    list({ commit }, id) {
      commit('LIST', []);

      return service.list(id).then((list) => {
        commit('LIST', list);
      });
    },

    clear({ commit }) {
      commit('CLEAR');
    }
  }
};



// WEBPACK FOOTER //
// ./src/entities/club/club-history/club-history-single/club-history-single-store.js